import * as React from 'react'

export function BulbsSpot(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M16 5c4.97 0 9 1.188 9 2.653 0 1.464-4.03 2.653-9 2.653S7 9.117 7 7.653c0-.18.06-.361.18-.531C8.01 5.912 11.65 5 16 5zm-7.785 5.087c2.168.92 5.474 1.219 7.785 1.219 2.312 0 5.617-.3 7.785-1.22-.328 1.92-1.137 4.546-3.561 6.295-.203.187-.224.5-.224 1.125v3.686c0 .477-.153.946-.466 1.3-.5.567-1.575 1-3.534 1-1.96 0-3.034-.433-3.534-1-.313-.354-.466-.823-.466-1.3v-3.686c0-.625-.02-.938-.223-1.125-2.424-1.75-3.234-4.375-3.562-6.294zM17 26v-1.542c.894-.083 1.548-.274 2-.533V26c0 .55-.45 1-1 1s-1-.45-1-1zm-4 0v-2.075c.452.259 1.106.45 2 .533V26c0 .55-.45 1-1 1s-1-.45-1-1z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
